import { FETCHED_SESSION, CHANGED_SESSION, STARTED_CREATE_SESSION, ERRORED_CREATE_SESSION } from "../constants/sessionConstants";

export const fetchedSession = session => ({
  type: FETCHED_SESSION,
  session,
});

export const changedSession = session => ({
  type: CHANGED_SESSION,
  session,
});

export const startedCreateSession = () => ({
  type: STARTED_CREATE_SESSION,
});

export const erroredCreateSession = error => ({
  type: ERRORED_CREATE_SESSION,
  error,
});
